import React from "react";
import PropTypes from "prop-types";

import { useFlattenedDatacomponent } from "../../../../hooks/useDatacomponent";
import { BWGridAPI, GridHeader, GridTable } from "../../../../ui/BWGrid";
import Spec from "../../../../../models/Spec";
import { DescriptionColumn } from "../../../Specs/DescriptionColumn";

export const requestForQuotePDFSpecsDataComponentId =
  "requestForQuotePDFSpecsDataComponentId";

const columns = ["customNumber", "description"];
const columnOptions = {
  customNumber: {
    title: "Number",
    bold: true,
  },
  description: {
    render: DescriptionColumn,
  },
};

export const SpecsGrid = ({ specIds }) => {
  const dataComponent = useFlattenedDatacomponent(
    requestForQuotePDFSpecsDataComponentId
  );

  return (
    <BWGridAPI
      dataComponent={dataComponent}
      model={Spec}
      includes={[]}
      apiRoute="specs"
      apiFilters={{
        rootFilters: {
          $where: {
            id: {
              $in: specIds,
            },
          },
        },
        params: {
          omitDefaultModifier: true,
        },
      }}
      defaultSorting={[{ columnName: "customNumber", direction: "asc" }]}
      showSelectionColumn
      showSelectAll
    >
      <GridHeader headerText={"Add Spec Files"} />
      <GridTable columns={columns} columnOptions={columnOptions} />
    </BWGridAPI>
  );
};
SpecsGrid.propTypes = {
  specIds: PropTypes.arrayOf(PropTypes.string),
};
